<template>
  <Chart
    chartID="pain-chart"
    type="line"
    :labels="labels"
    :datasets="datasets"
    v-if="dataLoaded"
  ></Chart>
</template>

<script>
import Chart from "../../Chart.vue";
import { format } from "date-fns";

export default {
  name: "Charts",
  props: ["existingEntries"],
  components: { Chart },
  data() {
    return {
      dataLoaded: false,
      labels: [],
      datasets: [
        {
          label: "Pain Level",
          data: [],
          borderColor: ["rgba(255,201,56)"],
          backgroundColor: ["rgba(255,201,56)"],
          fill: false
        }
      ]
    };
  },
  async mounted() {
    // Load our data and wait until it's done before setting loaded to true.
    await this.populateChart();
    this.dataLoaded = true;
  },
  methods: {
    populateChart() {
      this.existingEntries.slice().reverse().forEach(entry => {
        // Add label to chart.
        const day = format(entry.date.seconds * 1000, "MMMM D, YYYY");
        this.labels.push(day);

        // Add data to our chart.
        this.datasets[0].data.push(entry.data.painLevel);
      });
    }
  }
};
</script>

<style>
</style>
